import classNames from 'classnames';
import React, {Component, Fragment} from 'react';
import './DashboardReports.scss';
import './DashboardTableBox.scss';
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

class DashboardReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasNextReportUpdated: false,
      tableViewActive: false,
      expanded: false
    };
  }

  setTableView() {
    this.setState({
      tableViewActive: true
    })
  }

  setNextReportView() {
    this.setState({
      tableViewActive: false
    })
  }

  // ------------
  // Getters
  // ------------

  get nextReport() {
    const reports =
      this.props.reports &&
      this.props.reports.sort((r1, r2) => {
        const date1 = new Date(r1.actionAt).getTime();
        const date2 = new Date(r2.actionAt).getTime();

        if (date1 < date2) {
          return -1;
        } else if (date1 > date2) {
          return 1;
        }
        return 0;
      });

    if (reports) {
      if (this.props.sortDirection === 'desc') {
        return reports.reverse()[0];
      }
      return reports[0];
    }
    return null;
  }

  get isNextReportsViewActive() {
    return this.props.nextReportActive && !this.state.tableViewActive
  }

  // ------------
  // Render
  // ------------
  render() {
    return (
      <div
        style={{ flex: this.props.colSpan }}
        className={classNames('card', 'dashboard-reports', 'dashboard-table-box', {
          'has-warnings': this.props.hasWarnings,
          expanded: this.state.expanded,
        })}
      >
        <div className={classNames('header', {
          'next-report-active': this.props.nextReportActive
        })}>
          <span className="header-title">
            <i className={`fa fa-${this.props.icon}`} />
            <span>
              {this.props.title} ({this.props.reports
                ? this.props.reports.length
                : 0})
            </span>
          </span>

          {this.props.nextReportActive && this.isNextReportsViewActive
            ? (
              <span className="table-view" onClick={() => this.setTableView()}>
                Table View
                 <i className="fa fa-table" />
              </span>
            ): null}

          {this.props.nextReportActive && !this.isNextReportsViewActive
            ? (
              <span className="table-view" onClick={() => this.setNextReportView()}>
                Next report view
                 <i className="fa fa-square-o" />
              </span>
            ): null}

          <button
            type="button"
            className="button primary small toggle-expanded"
            aria-label={this.state.expanded ? `Close ${this.props.title}` : `Expand ${this.props.title}`}
            aria-expanded={this.state.expanded}
            onClick={() => this.setState(({expanded, tableViewActive}) => ({
              expanded: !expanded,
              tableViewActive: expanded ? tableViewActive : true
            }))}
          >
            <i className={`fa fa-${this.state.expanded ? 'times' : 'expand'}`} aria-hidden="true" />
            {this.state.expanded && ' Close'}
          </button>
        </div>
        {this.nextReport &&
          this.isNextReportsViewActive && (
            <div
              className={classNames('next-report', {
                new: this.state.hasNextReportUpdated,
              })}
            >
              <div
                className="heading">{this.props.nextReportLabel} {this.nextReport.status === 'rejected' ?
                <span className="error-label">(REJECTED)</span> : ''}</div>
              <div className="next-report-content">
                <div className="info">
                  <div>
                    <b>Date:</b> {this.nextReport.date}
                  </div>
                  <div>
                    <b>Type:</b> {this.nextReport.formName}
                  </div>
                  {this.props.showOitName && (
                    <div>
                      <b>{this.props.oitShortLabel}:</b> {this.nextReport.getFullNameFor('acknowledger')}
                    </div>
                  )}
                </div>
                {!this.props.hideActions && (
                  <div className="action">
                    <button
                      className="button default small"
                      onClick={() => this.props.onViewReport(this.nextReport)}
                    >
                      {this.nextReport.status === 'scheduled' && (
                        <Fragment>
                          <i className="fa fa-plus" />
                          <span>{this.props.addReportLabel}</span>
                        </Fragment>
                      )}
                      {(this.nextReport.status === 'draft' || this.nextReport.status === 'rejected') && (
                        <Fragment>
                          <i className="fa fa-edit" />
                          <span>Complete draft</span>
                        </Fragment>
                      )}
                      {this.nextReport.getCanAcknowledge(this.props.userContext.scope) && (
                        <Fragment>
                          <i className="fa fa-thumbs-up" />
                          <span>Acknowledge report</span>
                        </Fragment>
                      )}
                      {this.nextReport.getCanApprove(this.props.userContext.scope) && this.props.userContext.scope !== 'oit' && (
                        <Fragment>
                          <i className="fa fa-check" />
                          <span>Approve report</span>
                        </Fragment>
                      )}
                      {this.nextReport.getCanApprove(this.props.userContext.scope) && this.props.userContext.scope === 'oit' && (
                        <Fragment>
                          <i className="fa fa-check" />
                          <span>Acknowledge report</span>
                        </Fragment>
                      )}
                      {this.nextReport.getCanApproveTwo(this.props.userContext.scope) && (
                        <Fragment>
                          <i className="fa fa-check"/>
                          <span>Approve report</span>
                        </Fragment>
                      )}
                      {this.nextReport.getCanApproveThree(this.props.userContext.scope) && (
                        <Fragment>
                          <i className="fa fa-check"/>
                          <span>Approve report</span>
                        </Fragment>
                      )}
                      {this.nextReport.getCanApproveFour(this.props.userContext.scope) && (
                        <Fragment>
                          <i className="fa fa-check"/>
                          <span>Approve report</span>
                        </Fragment>
                      )}
                      {this.nextReport.getCanApproveFive(this.props.userContext.scope) && (
                        <Fragment>
                          <i className="fa fa-check"/>
                          <span>Approve report</span>
                        </Fragment>
                      )}
                    </button>
                    {(this.nextReport.status === 'draft' || this.nextReport.status === 'rejected') && !!this.props.onDeleteReport && (
                      <button className="button danger small" onClick={() => this.props.onDeleteReport(this.nextReport)}>
                        <i className="fa fa-trash" />
                        <span>Delete</span>
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        {this.props.reports &&
        !this.isNextReportsViewActive &&
        this.props.reports.length ? (
          <div className="report-list">
            <table className="table table-small layout-auto">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  {this.props.showOitName && <th>{this.props.oitShortLabel}</th>}
                  {this.props.showOitName && <th>Phase</th>}
                  {this.props.showFtoName && <th>{this.props.ftoShortLabel}</th>}
                  {!this.props.hideActions && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {this.props.reports.map(report => (
                  <tr key={report.guid}>
                    <td>{report.date}</td>
                    <td>
                      {this.props.shortReportsName ? (
                        <span style={{ textTransform: 'uppercase' }}>
                          {report.type}
                        </span>
                      ) : (
                        report.formName
                      )}
                    </td>
                    {this.props.showOitName && (
                      <th>{report.getFullNameFor('acknowledger')}</th>
                    )}
                    {this.props.showOitName && (
                      <th>{report.trainingPhaseHeader}</th>
                    )}
                    {this.props.showFtoName && (
                      <th>
                        {report.author &&
                        report.getFullNameFor('author')
                        }
                      </th>
                    )}
                    {!this.props.hideActions && (
                      <td className="td-actions">
                        <button
                          className="button default small"
                          onClick={() => this.props.onViewReport(report)}
                        >
                          <i className={`fa fa-${this.props.viewReportIcon}`} />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
        {!this.nextReport && (
          <div className="no-reports">{this.props.noReportsMessage}</div>
        )}
      </div>
    );
  }
}

DashboardReports.propTypes = {};

const mapStateToProps = (state) => ({
  userContext: state.common.userContext,
  oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
  ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state)
});

export default connect(mapStateToProps)(DashboardReports);
